import {css, StyleSheet} from 'aphrodite';
import React from 'react';

export function ChatEmptyState(): JSX.Element {
  return <div className={css(styles.emptyState)}>There's no chat here.</div>;
}

const styles = StyleSheet.create({
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
